import Notify from '@assets/js/input/notify';

export const handleError = (e) => {
    const notify = new Notify();
    switch (e.status) {
        case 401:
            window.location.href = '/login';
            break;
        default:
            notify.showMessage(
                'onError',
                `${e.code ? e.code : ''} ${e.message ? e.message : 'Ошибка на стороне сервера.'}`,
            );
    }
};
